import { DoseSuggestion, NO_DOSE_SUGGESTION } from '../types/doseSuggestion.type'
import AXIOS_INSTANCE from './axiosInstance'

export * from '../types/doseSuggestion.type'

export type DoseSuggestionParams = {
  drug: string
  form: string
  strength?: string
  patientId: string
}

const isDrugMissing = (error: any) =>
  error?.response?.status === 422 &&
  (error?.response?.data?.errors ?? []).some((item: any) => item?.code === 'drug_missing')

/**
 * MedKB reference dose for a drug + form (+ strength) and this patient (age and weight come from
 * the record server-side). An unknown drug resolves to the empty answer; other errors are left to
 * the caller.
 */
export const fetchDoseSuggestion = async ({
  drug,
  form,
  strength,
  patientId
}: DoseSuggestionParams): Promise<DoseSuggestion> => {
  try {
    const { data } = await AXIOS_INSTANCE.get<DoseSuggestion>('dose_suggestions', {
      params: { drug, form, patient_id: patientId, ...(strength && { strength }) },
      skipNavigationFeedback: true
    })
    return data
  } catch (error: any) {
    if (isDrugMissing(error)) return NO_DOSE_SUGGESTION
    throw error
  }
}
